<template>
    <div class="base-bg" v-if="visible">
        <TopBar
                :title="$t('descriptions.bgm')"
                @onClickClose="close"
                @onClickSave="saveBgm"
        ></TopBar>
        <global-single>
            <template v-slot:global>
                <div class="bgm-global-box">
                    <audio preload="none" controls="controls" alt="example" :src="form.bgm"></audio>
                    <div class="bgm-global-btn">
                        <material-select :type="2" @selected="updateBgm">
                            <template slot="body">
                                <a-button type="primary">{{$t('actionTitles.changeCover')}}</a-button>
                            </template>
                        </material-select>
                        <a-button type="danger" class="set-delete-btn" @click="deleteBgm">
                            {{$t('actionTitles.delete')}}
                        </a-button>
                    </div>
                </div>
            </template>
            <template v-slot:single>
                <div>
                    <div class="sence-list">
                        <div class="list-item" v-for="(item,index) in senceList" :key="index">
                            <img :src="item.thumb_path"/>
                            <span>{{item.scene_title}}</span>
                            <div class="music" v-if="item.bg_music.bgm && item.bg_music.bgm != ''">
                                <van-icon :name="playing && playId == index?'pause-circle-o':'play-circle-o'" @click="player(item.bg_music.bgm,index)"/>
                            </div>
                            <div class="btns">
                                <material-select :type="2" @selected="updateSingleBgm">
                                    <template slot="body">
                                        <a-button type="primary" @click="clickSingleBgm(index)">{{$t('actionTitles.changeCover')}}</a-button>
                                    </template>
                                </material-select>
                                <a-button v-show="item.bg_music.bgm && item.bg_music.bgm != ''" icon="delete" type="danger" class="set-delete-btn" @click="deleteSingleBgm(index)">
                                </a-button>
                            </div>
                        </div>
                    </div>
                    <audio preload="none" id="audio" controls="controls" style="height: 0" alt="example" @ended="ended" :src="playUrl"></audio>
                </div>
            </template>
        </global-single>
    </div>
</template>

<script>
    import TopBar from "./TopBar.vue";
    import MaterialSelect from "@/components/MaterialSelect";
    import {mapGetters} from "vuex";
    import GlobalSingle from "./GlobalSingle";
    import Vue from 'vue';
    import { Icon } from 'vant';

    Vue.use(Icon);

    export default {
        name: "BgmView",
        components: {
            TopBar,
            MaterialSelect,
            GlobalSingle
        },
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                form: {
                    bgm: ''
                },
                senceList: [],
                playing: false,
                playId: '',
                playUrl: '',
                curSenceId: ''
            }
        },
        computed: {...mapGetters(["vrbase"])},
        created() {
            this.form = this.$deepClone(this.vrbase.ads);
            this.senceList = this.$deepClone(this.vrbase.scenes)
        },
        methods: {
            close() {
                this.$emit("close");
            },
            updateBgm(data) {
                this.form.bgm = data.url
            },
            deleteBgm() {
                this.form.bgm = ''
            },
            player(url,index){
                //是否url一致
                let isAlike = false
                if(this.playId == index){
                    isAlike = true
                }else{
                    isAlike = false
                }
                this.playId = index
                this.playUrl = url
                setTimeout(()=>{
                    var audio = document.querySelector('#audio');
                    if(this.playing){
                        if(isAlike){
                            audio.pause();
                            this.playing = false
                        }else{
                            audio.load();
                            audio.play();
                            this.playing = true
                        }
                    }else{
                        audio.play();
                        this.playing = true
                    }
                },100)
            },
            ended(){
                this.playId = ''
                this.playing = false
            },
            updateSingleBgm(data){
                this.$set(this.senceList[this.curSenceId].bg_music, "bgm", data.url)
            },
            clickSingleBgm(index){
                this.curSenceId = index
            },
            deleteSingleBgm(index){
                this.curSenceId=index
                this.senceList[this.curSenceId].bg_music.bgm = ''
            },
            saveBgm(){
                const vrbase = { ...this.vrbase, ads: this.form,scenes: this.senceList };
                this.$store
                    .dispatch(
                        "saveVRBase",
                        {
                            vrbase,
                            showLoading: true,
                        },
                        true
                    )
                    .then(() => {
                        this.close()
                    });
            }
        }
    }
</script>

<style lang="less" scoped>
    .bgm-global-box{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding-top: 20px;
        .bgm-global-btn{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 10px;
            padding-left: 20px;
            .set-delete-btn{
                margin-left: 15px;
            }
        }
    }

    .sence-list {
        .list-item {
            margin-bottom: 15px;
            padding-bottom: 15px;
            border-bottom: 1px solid #555555;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &:last-child {
                padding-bottom: 0;
                margin-bottom: 0;
                border-bottom: 0;
            }

            img {
                width: 30px;
                height: 30px;
                flex-shrink: 0;
            }

            span {
                font-size: 12px;
                color: #ffffff;
                flex: 1;
                margin: 0 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .music{
                width: 30px;
                height: 30px;
                margin-right: 10px;
                i{
                    font-size: 30px;
                    color: rgba(255,255,255,.5);
                }
            }
            .btns{
                flex-shrink: 0;
                display: flex;
                /deep/ .ant-btn{
                    font-size: 12px;
                    padding: 0 10px;
                    height: 30px;
                }
                .set-delete-btn{
                    margin-left: 6px;
                    font-size: 16px;
                    width: auto;
                    padding: 0 6px;
                }
            }
        }
    }

</style>
